module.exports = __webpack_public_path__ + "static/airmason_joanne-93e878e2c9c6dce35e00cdfe48f6366e.png";